import { DataElement, Doctor } from "../models/common";
import { UiUser, UserRole } from "../models/ui-user.model";
import { ServiceMetaData } from "../models/service-meta.model";
import { Tab, TabIdList } from "../models/tab.model";
import {
  Order,
  OrderSearchParams,
  OrderFile,
  SystemParam,
  SystemParamSubject,
  DrProfile,
  RXOpt,
  RXForm,
  RXNote,
  RXItem,
  PresetNote,
} from "../models/order.model";
import { SupplyOrder } from "../models/supply-order.model";
import { UserNotification, ChatContact, ChatTask } from "../models/chat.model";
import {
  REPORTS_SCREEN_TYPE_ENUM,
  Invoice,
  Receipt,
  BalanceRow,
  InvoiceReportsSearchParams,
} from "../models/invoices.model";
import { DashboardData } from "../models/dashboard.model";
import { Clinic } from "../models/clinic.model";
import { OperationReport } from "../models/operation_reports.model";
import { KpiConfig, LabKpiModel } from "../models/kpi.model";
import { AgentTask } from "../models/agent-tasks.model";
import { DistributionWaybillsResponse } from "../models/delivery.model";

export class AppState {
  _currentServiceCall?: Object = null;
  _currentAction?: string = "";
  _currentActionData?: any = "";
  _errorFromServer?: any = {};
  ui_requestSetLang?: string;
  ui_direction?: string;
  ui_navigation?: Tab;
  ui_tabNavigation?: Tab;
  ui_tabStore?: Map<string, Tab[]> = new Map();
  ui_tabIdList?: TabIdList;
  ui_activeTabs?: Tab[] = [];
  ui_mobileNavOpen?: boolean = false;
  orders?: Order[] = null;
  orderSearchParams?: OrderSearchParams = null;
  orderSearchMetadata?: ServiceMetaData = null;
  currentOrder?: Order = null;
  clinicList?: Clinic[] = [];
  agentClinicList?: Clinic[] = [];
  doctorList?: Doctor[] = [];
  stageList?: DataElement[] = [];
  urgencyList?: DataElement[] = [];
  supplyTypesList?: DataElement[] = [];
  deliverersList?: DataElement[] = [];
  systemParams?: SystemParamSubject[] = [];
  techIssuesList?: DataElement[] = [];
  techiniciansList?: DataElement[] = [];
  orderEmailTemplateList?: DataElement[] = [];
  focusOrderChatTab?: boolean;
  supplyOrders?: SupplyOrder[];
  supplyOrderSearchMetadata?: ServiceMetaData = null;
  supplySelectedClinic?: DataElement = null;
  selectedSupplyType?: DataElement = null;
  users?: UiUser[] = null;
  roleList?: UserRole[] = [];
  plantList?: DataElement[] = [];
  chatTaskStatusList?: DataElement[] = [];
  taskUsersList?: UiUser[] = [];
  generalTaskUsersList?: UiUser[] = [];
  selectedUser?: UiUser = null;
  usersSearchMetadata?: ServiceMetaData = null;
  lastSavedUser?: UiUser = null;
  userNotifications?: UserNotification[] = [];
  inboxResultsPerPage?: number = 50;
  currentChatContact?: ChatContact = null;
  currentChatTask?: ChatTask = null;
  currentFileToSend?: OrderFile = null;
  currentReportScreenType?: REPORTS_SCREEN_TYPE_ENUM =
    REPORTS_SCREEN_TYPE_ENUM.INVOICES;
  reportsSearchParams?: InvoiceReportsSearchParams = null;
  curReportInvoices?: Invoice[] = null;
  curReportReceipts?: Receipt[] = null;
  curReportBalanceRows?: BalanceRow[] = null;
  invoicesSearchMetadata?: ServiceMetaData = null;
  receiptsSearchMetadata?: ServiceMetaData = null;
  balanceSearchMetadata?: ServiceMetaData = null;
  clinicsSearchMetadata?: ServiceMetaData = null;
  curTotalDept?: number = 0;
  dashboardData?: DashboardData = null;
  quickSearchSupplyOrdersType?: string = null;
  userSelectedClinicId?: string = null;
  mngSelectedClinic?: Clinic = null;
  clinicsDetails?: Clinic[] = [];
  operationReports?: OperationReport[] = [];
  agentsList?: DataElement[] = [];
  labKpi?: LabKpiModel;
  clinicChainList?: DataElement[] = [];
  selectedClinicForKpi?: number;
  agentTasks?: AgentTask[];
  agentTasksSearchMetadata?: ServiceMetaData = null;
  drProfiles?: DrProfile[];
  drProfilesSearchMetadata?: ServiceMetaData = null;
  rxOpt?: RXOpt[] = [];
  curRXForm?: RXForm;
  rxPresetNotes?: RXNote[] = [];
  rxItems?: RXItem[] = [];
  presetNotes?: PresetNote[];
  presetNotesSearchMetadata?: ServiceMetaData = null;
  kpiConfig?: KpiConfig[] = [];
  currentDisplayedFileId?: string = null;
  qcModeSw?: boolean;
  inboxNeedsReload?: boolean = false;
  distributionWaybills?: DistributionWaybillsResponse = null;
  distributionWaybillsSearchMetadata?: ServiceMetaData = null;

  constructor() {
    this.ui_tabIdList = Object.freeze(new TabIdList());
    this.techIssuesList.loading = true;
    this.techiniciansList.loading = true;
    this.agentsList.loading = true;
    this.chatTaskStatusList.loading = true;
    this.clinicList.loading = true;
    this.agentClinicList.loading = true;
    this.clinicChainList.loading = true;
    this.doctorList.loading = true;
    this.stageList.loading = true;
    this.urgencyList.loading = true;
    this.supplyTypesList.loading = true;
    this.roleList.loading = true;
    this.rxOpt.loading = true;
    this.taskUsersList.loading = true;
    this.generalTaskUsersList.loading = true;
    this.systemParams.loading = true;
    this.plantList.loading = true;
    this.orderEmailTemplateList.loading = true;
    this.kpiConfig.loading = true;
    this.deliverersList.loading = true;
    this.qcModeSw = false;
  }
}
